import api from '@/services/api'

export default {
  /**
   * Get malls
   * @return {Array} malls
   */
  async getAll () {
    try {
      const res = await api.get('/malls')
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  },

  /**
   * Create mall
   * @param {Object} {name: String}
   * @return {Object} mall
   */
  async create (mall) {
    try {
      const res = await api.post('/malls', mall)
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  },

  /**
   * Create malls
   * @param {Object} {name: String}
   * @return {Object} mall
   */
  async update (mall) {
    try {
      const res = await api.put('/malls/' + mall.id, mall)
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  },

  /**
   * Update mall logo
   * @param {Number} id
   * @param {File} logo
   * @return {String} logo name
   */
  async updateLogo (id, logo) {
    try {
      let formData = new FormData()
      formData.append('file', logo)
      const res = await api.post('/malls/' + id + '/logo', formData)
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  },

  /**
   * Update mall edito
   * @param {Number} id
   * @param {String} edito
   * @return {String} mall updated
   */
  async updateEdito (id, edito) {
    try {
      const res = await api.patch('/malls/' + id + '/edito', edito)
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  },

  /**
   * Delete one mall by id
   * @param {Number} id
   */
  async delete (id) {
    try {
      const res = await api.delete('/malls/' + id)
      return res.data
    } catch (error) {
      throw `Malls api service ${error}`
    }
  }
}